// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~css/colors.css'","_gray-light":"#eaeaea","tr":"TableRow_tr__2HUX_"};